exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__container___kjMLI{padding:0 5%;max-width:100rem;margin:0 auto}@media screen and (min-width:1024px){.index-module__container___kjMLI{padding:0 10%}}@media screen and (min-width:1325px){.index-module__container___kjMLI{padding:0 12%}}@media (min-width:2000px){.index-module__container___kjMLI{max-width:120rem}}", ""]);

// exports
exports.locals = {
	"container": "index-module__container___kjMLI"
};